import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withState from './withState'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

export default compose(
  withRedux, // for managing error state
  withState, // for managing join URL state
  withMutation, // for fetching the join URL
  withEventHandlers // for form actions
)(UI)
